import { create } from "zustand";

type AppLanguage = "ar" | "en";

type AppStoreState = {
  language: AppLanguage;
  isDark: boolean;
  authToken: string | null;
  setLanguage: (language: AppLanguage) => void;
  toggleDarkMode: () => void;
  setAuthToken: (token: string | null) => void;
};

export const useAppStore = create<AppStoreState>((set) => ({
  language: "ar",
  isDark: false,
  authToken: null,
  setLanguage: (language) => set({ language }),
  toggleDarkMode: () => set((state) => ({ isDark: !state.isDark })),
  setAuthToken: (token) => set({ authToken: token }),
}));